import {
  type FieldDefinition,
  type InsuranceProviderFormSchema,
  JSONSchemaFieldType,
  type OrderedFieldDefinition,
  VisitExpiryStrategy,
} from "../../types";

const isValidField: FieldDefinition = {
  name: "isValid",
  title: "Is this insurance cover valid?",
  type: JSONSchemaFieldType.STRING,
  enum: ["true", "false"],
  enumTitles: ["Yes", "No"],
};

const isValidFieldOrdered: OrderedFieldDefinition = {
  name: "isValid",
  title: "Is this insurance cover valid?",
  type: JSONSchemaFieldType.STRING,
  enum: ["true", "false"],
  meta: {
    enumTitles: ["Yes", "No"],
  },
};

const genericVisitInsuranceSchema: InsuranceProviderFormSchema = {
  title: "Insurance visit details",
  description: "Form definition for generic insurance visit details",
  type: JSONSchemaFieldType.OBJECT,
  properties: [isValidField],
  orderedProperties: [isValidFieldOrdered],
};

export const genericVisitValidation = {
  expiryStrategy: VisitExpiryStrategy.Midnight,
  formSchema: genericVisitInsuranceSchema,
  validatorConfig: {
    errMessages: {},
  },
};
